<template>
  <div class="empty-state">
    <div v-if="emptyHeading" class="heading">
        <div class="subtitle">{{emptyHeading}}</div>
    </div>

    <div class="desc">{{desc}}</div>

    <img class="empty-image" src="../assets/images/Items.svg" alt="Empty icon" />

  </div>
</template>

<script>
export default {
  name: 'EmptyDashboardState',
  props:['emptyHeading', 'desc'],
  data(){
    return{
    };
  },
  computed: {
  },

  beforeMount(){

  },

  updated(){
  }

};
</script>

<style scoped>
  .empty-state {
    padding-bottom: 2rem;
  }
  .empty-state .heading{
    border-bottom:1px solid rgba(196, 196, 196, 0.5);
    border-radius:15px 15px 0 0;
    display:flex;
    justify-content:space-between;
    align-items:center;
    padding: 0 1.313rem;
    height:6.126rem;
  }

  .empty-state .desc {
    margin:2rem 0 1rem 0;
    width:100%;
    text-align:center;
  }

  .heading .subtitle{
    font-weight:700;
    font-size:1.25rem;
    color: #333436;
    width:100%;
    text-align:left;
  }

  .empty-image{
    width:150px;
    display:block;
    margin:auto;
  }
</style>
